<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BasePageTitle',
  mixins: [baseMixin],
  props: {
    title: {
      type: String,
      default: 'Page Title',
    },
    subtitle: {
      type: String,
      default: '',
    },
    subtitleOnTop: {
      type: Boolean,
      default: false,
    },
    subtitleClass: {
      type: String,
      default: 'subtitle-2 mb-0',
    },
  },
}
</script>

<template>
  <header class="mb-8">
    <h4
      v-if="subtitleOnTop"
      id="page-subtitle"
      :class="[!isMobileViewPort ? subtitleClass : 'body-2']"
    >
      {{ subtitle }}
    </h4>
    <h2
      id="page-title"
      :class="[
        !isMobileViewPort
          ? 'text-h4 mt-0 mb-8 font-weight-bold'
          : 'font-weight-medium',
      ]"
    >
      {{ title }}
    </h2>
    <h4
      v-if="!subtitleOnTop"
      id="page-subtitle"
      :class="[!isMobileViewPort ? subtitleClass : 'body-2']"
    >
      {{ subtitle }}
    </h4>
  </header>
</template>
